import {HabitationMonitoringService} from "../../../serverService/habitationMonitoring/HabitationMonitoringService";
import React, {useEffect, useState} from "react";
import {
    RaikoBaseCardContainer,
    RaikoCustomSelect,
    raikoCustomSelectItemGenerator, RaikoFlexAlignStart,
    RaikoGridOneColumn, RaikoLabel,
    showServerErrorMessage
} from "@moeindal/base-raiko-panel-components";
import {chartColors} from "../../../component/charts/utils/ChartColors";
import PieChartWithPaddingAngle, {
    preparePieChartItem
} from "../../../component/charts/pieChartWithPaddingAngle/PieChartWithPaddingAngle";
import PieChartLineInfo from "../../../component/charts/pieChartWithPaddingAngle/pieChartLineInfo/PieChartLineInfo";
import {css} from "@emotion/css";
import RaikoSegmentSelect, {
    raikoSegmentSelectItemGenerator
} from "../../../raikoComponents/raikoSegmentSelect/RaikoSegmentSelect";

export default function HabitationMonitoringPieChartAccommodationReserver({periodId, refreshFlag = false}) {


    const service = new HabitationMonitoringService()


    const [accommodationReserveData, setAccommodationReserveData] = useState({})
    const [accommodationReserveFilters, setAccommodationReserveFilters] = useState([
        raikoCustomSelectItemGenerator("HABITATION", "اسکان ها"),
        raikoCustomSelectItemGenerator("COUPLE", "آقایان | خانم ها"),
        raikoCustomSelectItemGenerator("MAN", "آقایان"),
        raikoCustomSelectItemGenerator("WOMAN", "خانم ها")
    ])
    const accommodationReserveFilterKey = {
        "HABITATION": "numberOfReservation",
        "COUPLE": "totalPeople",
        "MAN": "numberOfMen",
        "WOMAN": "numberOfWomen"
    }

    const [selectedAccommodationReserve, setSelectedAccommodationReserve] = useState(accommodationReserveFilters[1].id)

    function getDataFromServer() {
        service.getAccommodationReserveStatus(periodId)
            .then(response => {
                const _habitation = []
                const _couple = []
                const _men = []
                const _women = []

                response.items.map((item, index) => {
                    _habitation.push(
                        preparePieChartItem(
                            item.title,
                            item[accommodationReserveFilterKey[accommodationReserveFilters[0].id]],
                            Object.values(chartColors)[index % 8]
                        )
                    )
                    _couple.push(
                        preparePieChartItem(
                            item.title,
                            item[accommodationReserveFilterKey[accommodationReserveFilters[1].id]],
                            Object.values(chartColors)[index % 8]
                        )
                    )
                    _men.push(
                        preparePieChartItem(
                            item.title,
                            item[accommodationReserveFilterKey[accommodationReserveFilters[2].id]],
                            Object.values(chartColors)[index % 8]
                        )
                    )
                    _women.push(
                        preparePieChartItem(
                            item.title,
                            item[accommodationReserveFilterKey[accommodationReserveFilters[3].id]],
                            Object.values(chartColors)[index % 8]
                        )
                    )
                })

                setAccommodationReserveData(
                    {
                        HABITATION: _habitation,
                        COUPLE: _couple,
                        MAN: _men,
                        WOMAN: _women,
                    }
                )

            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {

        })
    }

    useEffect(() => {
        if (typeof periodId !== "undefined" && periodId >= 0) {
            getDataFromServer()
        }
    }, [periodId]);

    useEffect(() => {
        if (typeof refreshFlag !== "undefined" && refreshFlag) {
            getDataFromServer()
        }
    }, [refreshFlag]);


    return <>
        <RaikoBaseCardContainer>
            <RaikoGridOneColumn>
                <RaikoFlexAlignStart className={css`align-items: center;`}>
                    <RaikoLabel
                        text={"اسکان ها"}
                        className={css`
                            white-space: nowrap;
                            width: 50%;`}
                    />
                    <RaikoSegmentSelect
                        value={selectedAccommodationReserve}
                        setValue={setSelectedAccommodationReserve}
                        items={[
                            raikoSegmentSelectItemGenerator("HABITATION", "اسکان"),
                            raikoSegmentSelectItemGenerator("COUPLE", "مجموع"),
                            raikoSegmentSelectItemGenerator("MAN", "آقا"),
                            raikoSegmentSelectItemGenerator("WOMAN", "خانم")
                        ]}
                    />
                    {/*<RaikoCustomSelect*/}
                    {/*    labelText={"فیلتر"}*/}
                    {/*    value={selectedAccommodationReserve}*/}
                    {/*    setValue={setSelectedAccommodationReserve}*/}
                    {/*    items={accommodationReserveFilters}*/}
                    {/*/>*/}
                </RaikoFlexAlignStart>
                <RaikoGridOneColumn>
                    <PieChartWithPaddingAngle
                        data={accommodationReserveData[selectedAccommodationReserve]}
                    />
                    <RaikoGridOneColumn>
                        {accommodationReserveData && accommodationReserveData[selectedAccommodationReserve] ?
                            accommodationReserveData[selectedAccommodationReserve].map((item, index) => {
                                return <PieChartLineInfo
                                    color={item.color}
                                    value={item.value}
                                    title={item.label}
                                />
                            }) : ""}
                    </RaikoGridOneColumn>

                </RaikoGridOneColumn>
            </RaikoGridOneColumn>
        </RaikoBaseCardContainer>
    </>


}